import { getStandardDateFormat, getDateAndTimeFormat } from 'utils/helpers/dateHelper';
export var formatAssignee = function (name) {
    if (!name)
        return 'None';
    return name;
};
export var parseTaskSnapshot = function (jsonString) {
    if (!jsonString)
        return null;
    try {
        var parsed = JSON.parse(jsonString);
        if (!parsed || typeof parsed !== 'object')
            return null;
        return parsed;
    }
    catch (_a) {
        return null;
    }
};
export var parseTaskNames = function (jsonString) {
    if (!jsonString)
        return null;
    try {
        var parsed = JSON.parse(jsonString);
        if (!Array.isArray(parsed))
            return null;
        return parsed.filter(function (name) { return typeof name === 'string'; });
    }
    catch (_a) {
        return null;
    }
};
var formatDueDate = function (value) {
    return value ? getStandardDateFormat(value) : 'No due date';
};
var formatCompletedAt = function (value) {
    return value ? "Completed ".concat(getDateAndTimeFormat(value)) : 'Not completed';
};
var formatTaskType = function (id) {
    return id == null ? 'No type' : "Type:".concat(id);
};
export var diffTaskSnapshots = function (oldSnapshot, newSnapshot) {
    if (!oldSnapshot || !newSnapshot)
        return [];
    var changes = [];
    var pushChange = function (label, from, to, changed) {
        if (changed)
            changes.push({ label: label, from: from, to: to });
    };
    pushChange('Task', oldSnapshot.body || '', newSnapshot.body || '', oldSnapshot.body !== newSnapshot.body);
    pushChange('Due date', formatDueDate(oldSnapshot.due_date), formatDueDate(newSnapshot.due_date), oldSnapshot.due_date !== newSnapshot.due_date);
    pushChange('Assignee', formatAssignee(oldSnapshot.assigned_to), formatAssignee(newSnapshot.assigned_to), oldSnapshot.assigned_to !== newSnapshot.assigned_to);
    pushChange('Completed by', formatAssignee(oldSnapshot.completed_by), formatAssignee(newSnapshot.completed_by), oldSnapshot.completed_by !== newSnapshot.completed_by);
    pushChange('Type', formatTaskType(oldSnapshot.task_type_id), formatTaskType(newSnapshot.task_type_id), oldSnapshot.task_type_id !== newSnapshot.task_type_id);
    pushChange('Status', formatCompletedAt(oldSnapshot.completed_at), formatCompletedAt(newSnapshot.completed_at), Boolean(oldSnapshot.completed_at) !== Boolean(newSnapshot.completed_at));
    return changes;
};
var arraysEqual = function (a, b) {
    return a.length === b.length && a.every(function (value, index) { return value === b[index]; });
};
export var describeTaskNamesChange = function (oldNames, newNames) {
    var oldList = oldNames || [];
    var newList = newNames || [];
    if (oldNames && newNames && arraysEqual(oldList, newList)) {
        return { mode: 'reassign', added: [], removed: [], reassigned: newList };
    }
    var added = newList.filter(function (name) { return !oldList.includes(name); });
    var removed = oldList.filter(function (name) { return !newList.includes(name); });
    var mode;
    if (!oldNames || removed.length === 0) {
        mode = 'added';
    }
    else if (added.length === 0) {
        mode = 'removed';
    }
    else {
        mode = 'swapped';
    }
    return { mode: mode, added: added, removed: removed, reassigned: [] };
};
